import { useCallback } from 'react';
import useLocalStorageState from 'use-local-storage-state';
import { LOCAL_STORAGE_LAST_SEND_OTP_TIME } from '../constansts/index.js';
import '../components/ContextProvider/components/IsOTPSendedProvider/provider.js';
import { useIsOTPSended } from '../components/ContextProvider/components/IsOTPSendedProvider/hook.js';
import '../components/ContextProvider/components/MetainfoProvider/provider.js';
import { useMetainfo } from '../components/ContextProvider/components/MetainfoProvider/hook.js';
import '../components/ContextProvider/components/UserManagerProvider/provider.js';
import { useUserManager } from '../components/ContextProvider/components/UserManagerProvider/hook.js';

function useSendOtpByPhoneNumber() {
    const [_, setLastSendOtpTime] = useLocalStorageState(LOCAL_STORAGE_LAST_SEND_OTP_TIME, {
        storageSync: true,
        ssr: true,
    });
    const [__, setIsOTPSended] = useIsOTPSended();
    const metainfo = useMetainfo();
    const userManager = useUserManager();
    const sendOtpByPhoneNumber = useCallback(async (data) => {
        const result = await userManager.sendOtpToPhoneNumber({ ...metainfo, ...data });
        if (result.isOk()) {
            setLastSendOtpTime(Date.now());
            setIsOTPSended(true);
        }
        return result;
    }, [userManager, metainfo, setLastSendOtpTime, setIsOTPSended]);
    return sendOtpByPhoneNumber;
}

export { useSendOtpByPhoneNumber };
//# sourceMappingURL=useSendOtpByPhoneNumber.js.map
